export default {
  en: {
    ADDRESS_ADD_BUTTON: 'Create Address',
    ADDRESS_ADD_SUCCESS: 'Address created',
    ADDRESS_CALLER_PROFILE_ZIPCODE_DESCRIPTION: 'Collected from caller\'s profile',
    ADDRESS_CALLER_PROFILE_ZIPCODE: 'ICP/Profile',
    ADDRESS_CITY_TT: 'City',
    ADDRESS_CITY: 'City',
    ADDRESS_COMPANY_TT: 'Name of the business in a specified country',
    ADDRESS_COMPANY: 'Business name',
    ADDRESS_COUNTRY_PLACEHOLDER: 'Search Country',
    ADDRESS_COUNTRY_TT: 'Country in which the address is registered',
    ADDRESS_COUNTRY: 'Country',
    ADDRESS_NAME_TT: 'Unique name of the address',
    ADDRESS_NAME: 'Name',
    ADDRESS_SAVE_BUTTON: 'Save changes',
    ADDRESS_STATE_TT: 'State or region',
    ADDRESS_STATE: 'State/Region',
    ADDRESS_STREET_TT: 'Street address, including the unit/office number',
    ADDRESS_STREET: 'Street address',
    ADDRESS_UPDATE_SUCCESS: 'Address updated',
    ADDRESS_ZIP_TT: 'ZIP or Postal Code',
    ADDRESS_ZIP: 'ZIP/Postal Code',
    ADDRESSES_ACTIONS: 'Actions',
    ADDRESSES_BUSINESS: 'Business Name',
    ADDRESSES_COMBINED: 'Address',
    ADDRESSES_COUNTRY: 'Country',
    ADDRESSES_EDIT_ACTION: 'Edit',
    ADDRESSES_HEADER_LOADING: 'Loading Addresses...',
    ADDRESSES_HEADER_NONE: 'You do not have any registered addresses on file',
    ADDRESSES_ID: 'ID',
    ADDRESSES_NAME: 'Name',
    ADDRESSES_NEW: 'New',
    ADDRESSES_REMOVE_ACTION: 'Remove',
    ADDRESSES_TITLE: 'Manage Addresses',
    ADRESSES_CREATE_NEW_ADDRESS: 'Add Address',
    ADDRESSES_ADDRESS: 'Address',
    ACTION_ADD_ADDRESS: 'Add Address',

    PLACEHOLDER_ADDRESS_SEARCH: 'Search Addresses',

    MESSAGE_UPDATE_SUCCESS: 'Address updated',
    MESSAGE_CREATE_SUCCESS: 'Address created',
    MESSAGE_DELETE_SUCCESS: 'Address deleted successfully',

    //Table
    TABLE_HEADER_COL_ADDRESS: 'Address',
    TABLE_HEADER_COL_REPORTING_MENU_NAME: 'Reporting Menu Name',
    TABLE_HEADER_COL_REPORT_NAME: 'Report Name',
    INPUT_LABEL_ADDRESS: 'Address',
    INPUT_LABEL_ADDRESS_TT: 'The address you\'d like Ringba to tag.',
    INPUT_LABEL_REPORTING_MENU_NAME: 'Reporting Menu Name',
    INPUT_LABEL_REPORTING_MENU_NAME_TT:
      'The Menu Option in Reporting under the Tags menu where you can find this data.',
    INPUT_LABEL_REPORT_NAME: 'Report Name',
    INPUT_LABEL_REPORT_NAME_TT:
      'The name of the report that will show up in your Menu Name.',
    TT_DELETE: 'Delete Address',

    ADDRESS_TABLE_LOADING: 'Loading Addresses',
    ADDRESS_TABLE_EMPTY: 'You do not have any registered addresses on file',

    //Modal
    TITLE_DELETE: 'Delete Address',
    'DELETE_ADDRESS_MODAL_MESSAGE': 'Do you want to delete this address?',
    LABEL_DELETE_MODAL_MESSAGE_ASSOCIATION_LOADED:
      'Are you sure you want to delete this Address?{0}It is currently associated with the following items:',
    LABEL_DELETE_MODAL_MESSAGE_ASSOCIATION_ERROR:
      'An error occurred while determining associated campaigns, please try again.',
    LABEL_DELETE_MODAL_MESSAGE_ASSOCIATION_LOADING:
      'Determining if this Address is currently associated with any campaigns.',
    LABEL_DELETE_MODAL_MESSAGE_ASSOCIATION_EMPTY:
      'The Address is not associated with any campaign.',
    LABEL_DELETE_MODAL_CAMPAIGNS: 'Campaigns',
    TT_VIEW_CAMPAIGN: 'View Campaign',
    TITLE_DELETE_INVITE: 'Confirm Delete Address',

    ADDRESS_CREATE_AND_ADD_SUCCESS: 'Address created and linked.',
    ADDRESS_CALL_ID_DEFAULT: 'call_id',
    ADDRESS_CALL_ID_TT:
      'The URL variable your system will pass back our Call ID with.',
    ADDRESS_CAMPAIGN_SPECIFIC_TT:
      'Only fire the campaign-specific pixels when triggered.',
    ADDRESS_CAMPAIGN_SPECIFIC: 'Campaign Specific',
    ADDRESS_CANCEL_BUTTON: 'Cancel',
    ADDRESS_CREATE_SUCCESS: 'Address created.',
    ADDRESS_CREATE_ADDRESS: 'Create Address',
    ADDRESS_DELETE_SUCCESS: 'Address deleted.',
    ADDRESS_EXISTING_ACTIONS: 'Actions',
    ADDRESS_EXISTING_CALL_ID: 'Call Token',
    ADDRESS_EXISTING_CONVERSION_CHECK: 'Fire Pixels',
    ADDRESS_EXISTING_DELETE_TT: 'Delete',
    ADDRESS_EXISTING_EDIT_TT: 'Edit',
    ADDRESS_EXISTING_ENABLED: 'Enabled',
    ADDRESS_EXISTING_ENDPOINT_CALL_IT: '[Call_ID]',
    ADDRESS_EXISTING_ENDPOINT_REVENUE_AMOUNT: '[Revenue]',
    ADDRESS_EXISTING_ENDPOINT_URL: 'Endpoint',
    ADDRESS_EXISTING_REVENUE: 'Revenue Token',
    ADDRESS_HEADER_NONE: 'You do not have any registered addresses on file',
    ADDRESS_HEADER_TT:
      'Add a address to pass data into any of your compaigns for more accurate tracking.',
    ADDRESS_HEADER: 'Manage Addresses',
    ADDRESS_LOADING: 'Loading Addresses.',
    ADDRESS_NAME_DEFAULT: 'My Address',
    ADDRESS_PAGE_TITLE: 'Addresses',
    ADDRESS_REVENUE_DEFAULT: 'call_revenue',
    ADDRESS_REVENUE_TT:
      'The URL Variable your system will pass back revenue with.',
    ADDRESS_REVENUE: 'Revenue Token',
    ADDRESS_UPDATE_BUTTON: 'Update',
  }
};
